import { render, staticRenderFns } from "./contact-request.vue?vue&type=template&id=026be712&scoped=true&"
import script from "./contact-request.vue?vue&type=script&lang=js&"
export * from "./contact-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026be712",
  null
  
)

export default component.exports